import { render, staticRenderFns } from "./DirectoryModules.vue?vue&type=template&id=12e801ec&"
import script from "./DirectoryModules.vue?vue&type=script&lang=js&"
export * from "./DirectoryModules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports